module.exports = __webpack_public_path__ + "img/code-info.b87759e6.png";